import { Info, X } from "lucide-react";

interface CopyRoutineInfoCardProps {
  open: boolean;
  onClose: () => void;
}

export const CopyRoutineInfoCard = ({ open, onClose }: CopyRoutineInfoCardProps) => {
  if (!open) return null;

  return (
    <div className="max-w-xl mx-auto mb-6 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md p-4 shadow-sm animate-in fade-in slide-in-from-top-2">
      <div className="flex items-start gap-3">
        <div className="shrink-0 rounded-full bg-primary/15 p-2">
          <Info className="h-4 w-4 text-primary" />
        </div>
        <div className="flex-1 space-y-2 text-sm">
          <div className="flex items-center justify-between gap-2">
            <h3 className="font-semibold text-primary">¿Cómo copiar una rutina?</h3>
            <button
              type="button"
              onClick={onClose}
              aria-label="Cerrar"
              className="rounded-full p-1 hover:bg-white/10 transition"
            >
              <X className="h-4 w-4 text-muted-foreground" />
            </button>
          </div>
          <ol className="list-decimal list-inside space-y-1 text-muted-foreground">
            <li>Tocá "Copiar" en la rutina que te interese.</li>
            <li>Abrí tu plan personal o un plan que ya hayas copiado.</li>
            <li>Tocá "Agregar rutina" dentro del plan: ahí van a aparecer todas las rutinas que copiaste.</li>
            <li>Seleccionala para sumarla al plan y entrenarla cuando quieras.</li>
          </ol>
          <p className="text-xs text-muted-foreground/80">
            Las rutinas copiadas quedan disponibles para agregarse a cualquiera de tus planes.
          </p>
        </div>
      </div>
    </div>
  );
};
